<head>
  <title></title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>

<div class="table-container">
  <div class="d-flex justify-content-between">
    <div>
      <app-breadcrumb></app-breadcrumb>
    </div>
    <div class="d-flex gap-3">
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        *ngIf="message.isAuditTrailUser" (click)="openAuditTrail()" (keydown.enter)="openAuditTrail()">
        <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Audit Trail</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        *ngIf="!isQmsSettingsDataEmpty" (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        *ngIf="!isQmsSettingsDataEmpty" (click)="openReport('Pdf')" (keydown.enter)="openReport('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
      <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="refreshForm()"
        (keydown.enter)="refreshForm()">
        <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
        <span class="reload_text">Reload</span>
      </div>
    </div>
  </div>

  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>

  <div class="dataEmpty">
    <div class="row" *ngIf="isQmsSettingsDataEmpty">The form presently lacks any content</div>
  </div>

  <div class="form form-content" *ngIf="!isQmsSettingsDataEmpty">
    <fieldset class="border p-2" [hidden]="organizationPrivelegesDetails.cr!=true">
      <legend class="float-none w-auto p-2"><span class="legent-title">{{editorTitleMapping['CR']}}</span></legend>
      <div class="row">
        <div class="col-md-4">
          <div><label for="email">ID Format</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.crIdFormat">
        </div>
        <div class="col-md-4">
          <div><label for="email">ID Regeneration</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.crIdRegeneration">
        </div>
        <div class="col-md-4">
          <div><label for="email">ID No. of Digits</label></div>
          <input class="input-filed-continers" type="number" min="1" (keydown)="validateNoOfDigitsFields($event)"
            [(ngModel)]="qmsSettingsObj.crIdNoOfDigits">
        </div>
      </div>
    </fieldset>

    <fieldset class="border p-2" [hidden]="organizationPrivelegesDetails.capa!=true">
      <legend class="float-none w-auto p-2"><span class="legent-title">{{editorTitleMapping['CAPA']}}</span></legend>
      <div class="row">
        <div class="col-md-4">
          <div><label for="email">ID Format</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.capaIdFormat">
        </div>
        <div class="col-md-4">
          <div><label for="email">ID Regeneration</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.capaIdRegeneration">
        </div>
        <div class="col-md-4">
          <div><label for="email">ID No. of Digits</label></div>
          <input class="input-filed-continers" type="number" min="1" (keydown)="validateNoOfDigitsFields($event)"
            [(ngModel)]="qmsSettingsObj.capaIdNoOfDigits">
        </div>
      </div>
    </fieldset>

    <fieldset class="border p-2" [hidden]="organizationPrivelegesDetails.dv!=true">
      <legend class="float-none w-auto p-2"><span class="legent-title">{{editorTitleMapping['DV']}}</span></legend>
      <div class="row">
        <div class="col-md-4">
          <div><label for="email">ID Format</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.dvIdFormat">
        </div>
        <div class="col-md-4">
          <div><label for="email">ID Regeneration</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.dvIdRegeneration">
        </div>
        <div class="col-md-4">
          <div><label for="email">ID No. of Digits</label></div>
          <input class="input-filed-continers" type="number" min="1" (keydown)="validateNoOfDigitsFields($event)"
            [(ngModel)]="qmsSettingsObj.dvIdNoOfDigits">
        </div>
      </div>
    </fieldset>

    <fieldset class="border p-2" [hidden]="organizationPrivelegesDetails.au!=true">
      <legend class="float-none w-auto p-2"><span class="legent-title">{{editorTitleMapping['AU']}}</span></legend>
      <div class="row">
        <div class="col-md-4">
          <div><label for="email">ID Format</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.auIdFormat">
        </div>
        <div class="col-md-4">
          <div><label for="email">ID Regeneration</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.auIdRegeneration">
        </div>
        <div class="col-md-4">
          <div><label for="email">ID No. of Digits</label></div>
          <input class="input-filed-continers" type="number" min="1" (keydown)="validateNoOfDigitsFields($event)"
            [(ngModel)]="qmsSettingsObj.auIdNoOfDigits">
        </div>
      </div>
    </fieldset>

    <fieldset class="border p-2" [hidden]="organizationPrivelegesDetails.in!=true">
      <legend class="float-none w-auto p-2"><span class="legent-title">{{editorTitleMapping['IN']}}</span></legend>
      <div class="row">
        <div class="col-md-4">
          <div><label for="email">ID Format</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.inIdFormat">
        </div>
        <div class="col-md-3">
          <div><label for="email">ID Regeneration</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.inIdRegeneration">
        </div>
        <div class="col-md-2">
          <div><label for="email">ID No. of Digits</label></div>
          <input class="input-filed-continers" type="number" min="1" (keydown)="validateNoOfDigitsFields($event)"
            [(ngModel)]="qmsSettingsObj.inIdNoOfDigits">
        </div>
        <div class="col-md-3">
          <div><label for="email">Incident Group</label></div>
          <mat-select matInput placeholder="Select"
            [ngClass]="{'odd-item-mat-select': oddIncidentGroup== selectedIncidentGroup}"
            [(ngModel)]="selectedIncidentGroup" (closed)="incidentGroupsearchTxt=''"
            (click)="focusmethod('incidentgroupfocusSearch')" (keydown.enter)="focusmethod('incidentgroupfocusSearch')"
            (focus)="focusEmpty()">
            <input type="search" id="incidentgroupfocusSearch" class="dropdownsearchstyle"
              [(ngModel)]="incidentGroupsearchTxt" matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onIncidentGroupSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of incidentGroupDropdown| assessmentSearch :incidentGroupsearchTxt"
              (onSelectionChange)="onIncidentGroupSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </fieldset>

    <fieldset class="border p-2" [hidden]="organizationPrivelegesDetails.qi!=true">
      <legend class="float-none w-auto p-2"><span class="legent-title">{{editorTitleMapping['QI']}}</span></legend>
      <div class="row">
        <div class="col-md-4">
          <div><label for="email">ID Format</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.qiIdFormat">
        </div>
        <div class="col-md-4">
          <div><label for="email">ID Regeneration</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.qiIdRegeneration">
        </div>
        <div class="col-md-4">
          <div><label for="email">ID No. of Digits</label></div>
          <input class="input-filed-continers" type="number" min="1" [(ngModel)]="qmsSettingsObj.qiIdNoOfDigits"
            (keydown)="validateNoOfDigitsFields($event)">
        </div>
      </div>
    </fieldset>
    <fieldset class="border p-2" [hidden]="organizationPrivelegesDetails.oos!=true">
      <legend class="float-none w-auto p-2"><span class="legent-title">{{editorTitleMapping['OOS']}}</span></legend>
      <div class="row">
        <div class="col-md-4">
          <div><label for="email">ID Format</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.oosIdFormat">
        </div>
        <div class="col-md-4">
          <div><label for="email">ID Regeneration</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.oosIdRegeneration">
        </div>
        <div class="col-md-4">
          <div><label for="email">ID No. of Digits</label></div>
          <input class="input-filed-continers" type="number" min="1" [(ngModel)]="qmsSettingsObj.oosIdNoOfDigits"
            (keydown)="validateNoOfDigitsFields($event)">
        </div>
      </div>
    </fieldset>
    <fieldset class="border p-2" [hidden]="organizationPrivelegesDetails.cc!=true">
      <legend class="float-none w-auto p-2"><span class="legent-title">{{editorTitleMapping['CC']}}</span></legend>
      <div class="row">
        <div class="col-md-4">
          <div><label for="email">ID Format</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.ccIdFormat">
        </div>
        <div class="col-md-4">
          <div><label for="email">ID Regeneration</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.ccIdRegeneration">
        </div>
        <div class="col-md-4">
          <div><label for="email">ID No. of Digits</label></div>
          <input class="input-filed-continers" type="number" min="1" (keydown)="validateNoOfDigitsFields($event)"
            [(ngModel)]="qmsSettingsObj.ccIdNoOfDigits">
        </div>
      </div>
    </fieldset>

    <div class="row fieldStyle">
      <div class="col-md-4">
        <div><label for="email">Intimate Audit Schedule Before N Days</label></div>
        <input class="input-filed-continers" type="number" min="1" (keydown)="validateNoOfDigitsFields($event)"
          [(ngModel)]="qmsSettingsObj.intimateAuditScheduleBeforeNDays">
      </div>
      <div class="col-md-4">
        <div><label for="email">Reports Timezone</label></div>
        <mat-select matInput placeholder="Select" [ngClass]="{'odd-item-mat-select': oddTimezone== selectedTimeZone}"
          [(ngModel)]="selectedTimeZone" (closed)="reportsTimezonesearchTxt=''"
          (click)="focusmethod('reportsTimezonefocusSearch')"
          (keydown.enter)="focusmethod('reportsTimezonefocusSearch')">
          <input type="search" id="reportsTimezonefocusSearch" class="dropdownsearchstyle"
            [(ngModel)]="reportsTimezonesearchTxt" matInput placeholder="Search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onReportsTimezoneSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of timeZoneListDropdown | assessmentSearch :reportsTimezonesearchTxt"
            (onSelectionChange)="onReportsTimezoneSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-4">
        <div><label for="email">Risk Formula</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.riskFormula">
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div><label for="email">PDF Footer Content</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="qmsSettingsObj.pdfFooterContent">
      </div>
      <div class="col-md-6">
        <div><label for="email">Allowed File Extensions</label></div>
        <mat-select matInput multiple placeholder="Select" #reasonForChange
          [(ngModel)]="qmsSettingsObj.selectedAllowedFileExtns" (closed)="allowedFileExtnsSearchText=''"
          (click)="focusSearch('focusSearch')" (keydown.enter)="focusSearch('focusSearch')">
          <input type="search" id="focusSearch" class="dropdownsearchstyle" [(ngModel)]="allowedFileExtnsSearchText"
            matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="allSelected" (change)="toggleAllSelection('reasonForChange')">Select
              All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item1 of allowedFileExtnList| multiAssessmentSearchPipe :allowedFileExtnsSearchText"
            [value]="item1.valueExp">
            {{ item1.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-4">
        <div><label for="email">Primary Selector</label></div>
        <mat-select matInput placeholder="Select" (closed)="primarySelectorSearchTxt=''"
          [(ngModel)]="selectPrimarySelectorAtUIPage" (click)="focusmethod('primarySelectorfocusSearch')"
          (keydown.enter)="focusmethod('primarySelectorfocusSearch')">
          <input type="search" id="primarySelectorfocusSearch" class="dropdownsearchstyle"
            [(ngModel)]="primarySelectorSearchTxt" matInput placeholder="Search">
          <mat-option *ngFor="let item of primarySelectorList | assessmentSearch :primarySelectorSearchTxt"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-7">
        <div><label for="email">Module Tabs</label></div>
        <textarea type="text" class="input-filed-continers" rows="10" cols="50"
          style="width: 100% !important; height: 80px !important;"
          [(ngModel)]="qmsSettingsObj.tabPagesOrder"></textarea>
      </div>
      <div class="col-md-1 d-flex align-items-center">
        <div (click)="openreorder()" (keydown.enter)="openreorder()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#000000"
            matTooltip="Module Tabs Reorder">
            <path style="fill:'#ffffff'"
              d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
          </svg>
        </div>
      </div>
    </div>
    <br>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="saveQmsSettings(qmsSettingsObj)">
        <i class="fa fa-save"></i> Save
      </button>
    </div>
  </div>
</div>


<ng-template #reorderPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReorderFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>

  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Module tabs Reorder</label>
  </div>
  <div class="table-container">
    <div class="align-center">
      <table style="max-height: 500px;">
        <thead>
          <th style="width: 80px; text-align: center;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"> <span>Curr. Seq.</span> <span id="grid-header-container"></span> </th>
          <th style="min-width: 375px;text-align: left;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"> <span>Field Name</span> <span class="grid-header-container"></span> </th>
          <th style="width: 80px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"> <span>New Seq.</span> <span classs="grid-header-container"></span> </th>
        </thead>
        <tbody cdkDropList (cdkDropListDropped)="drop($event)">
          <tr cdkDrag cdkDragLockAxis="y" cdkDragHandle *ngFor="let item of contentList let idx = index;">
            <td id="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
            white-space: 'nowrap'"><span>{{item.currentSeq}}</span></td>
            <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{item.fieldName}}</span></td>
            <td class="grid-row-container " style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
              white-space: 'nowrap'"><span>{{item.newSeq}}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="button-continer" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="resetFunction()">
      <i class="fa fa-reset"></i> Reset
    </button>
    <button mat-stroked-button class="addButton" (click)="reorderContentFunction()">
      <i class="fa fa-redorder"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReorderFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>

</ng-template>
<ng-template #resetOrderPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReorderFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Module tabs Reorder</label>
  </div>
  <div class="table-container">
    <label for="resetConfirm">Are you sure do you want to reset tab order in the list</label>
  </div>
  <div label="container " class="button-continer" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="resetList()">
      <i class="fa fa-redorder"></i> yes
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelResetList()">
      <i class="fa fa-close"></i> No
    </button>
  </div>

</ng-template>

<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>